export enum StatusInvite {
  NOT_SENT = 0,
  SENT = 1,
  INVALID_EMAIL = 2,
  INVALID_CRM = 3,
  INVALID_TOKEN = 4,
  EMAIL_REGISTERED = 5,
}